import { render, staticRenderFns } from "./trap_site_details.vue?vue&type=template&id=4d3f48ac&"
import script from "./trap_site_details.vue?vue&type=script&lang=js&"
export * from "./trap_site_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports